// Central data-testid registry for Brushmaster.art
export const SPLASH = {
  root: "splash-root",
  logo: "splash-logo",
  heading: "splash-heading",
  emailInput: "splash-email-input",
  submitBtn: "splash-submit-btn",
  successMessage: "splash-success-message",
  enterSiteLink: "splash-enter-site-link",
};

export const NAV = {
  root: "site-nav",
  logo: "site-nav-logo",
  galleryLink: "nav-gallery-link",
  artistLink: "nav-artist-link",
  reserveLink: "nav-reserve-link",
  adminLink: "nav-admin-link",
};

export const HERO = {
  root: "hero-root",
  heading: "hero-heading",
  viewGalleryBtn: "hero-view-gallery-btn",
  reserveBtn: "hero-reserve-btn",
};

export const GALLERY = {
  root: "gallery-root",
  card: (id) => `gallery-card-${id}`,
  cardImage: (id) => `gallery-card-image-${id}`,
  cardTitle: (id) => `gallery-card-title-${id}`,
  reserveBtn: (id) => `gallery-reserve-btn-${id}`,
  viewBtn: (id) => `gallery-view-btn-${id}`,
  lightbox: "gallery-lightbox",
  lightboxClose: "gallery-lightbox-close",
};

export const ARTIST = {
  root: "artist-story",
  heading: "artist-story-heading",
};

export const TRUST = {
  root: "trust-section",
  certificatePreview: "trust-certificate-preview",
  letterPreview: "trust-letter-preview",
};

export const RESERVE = {
  dialog: "reserve-dialog",
  name: "reserve-name-input",
  email: "reserve-email-input",
  phone: "reserve-phone-input",
  message: "reserve-message-input",
  submit: "reserve-submit-btn",
  cancel: "reserve-cancel-btn",
  success: "reserve-success-message",
};

export const FOOTER = {
  root: "site-footer",
  newsletterEmail: "footer-newsletter-email",
  newsletterSubmit: "footer-newsletter-submit",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",
  layout: "admin-layout",
  logoutBtn: "admin-logout-btn",
  navReservations: "admin-nav-reservations",
  navVisitors: "admin-nav-visitors",
  navSignups: "admin-nav-signups",
  navArtworks: "admin-nav-artworks",
  reservationRow: (id) => `admin-reservation-row-${id}`,
  approveBtn: (id) => `admin-approve-btn-${id}`,
  cancelBtn: (id) => `admin-cancel-btn-${id}`,
  payLink: (id) => `admin-pay-link-${id}`,
  artworkRow: (id) => `admin-artwork-row-${id}`,
  addArtworkBtn: "admin-add-artwork-btn",
  artworkFormSubmit: "admin-artwork-form-submit",
  artworkFormTitle: "admin-artwork-form-title",
  artworkFormPrice: "admin-artwork-form-price",
  artworkFormImage: "admin-artwork-form-image",
  artworkFormDescription: "admin-artwork-form-description",
  deleteArtworkBtn: (id) => `admin-delete-artwork-btn-${id}`,
};
